import { createApp } from 'vue';
import VueSmartcaptcha from './VueSmartcaptcha.vue';

const app = createApp(VueSmartcaptcha);
app.mount('#smart-captcha');
